import React, { useState } from 'react';
import { TextField, Button, Box, Typography, CircularProgress } from '@mui/material';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from 'react-router-dom';

const Login = ({ setUser }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const auth = getAuth();

    const handleLogin = async (event) => {
        event.preventDefault();
        setError('');
        setLoading(true);
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            setUser(userCredential.user);
            navigate('/calendar');
        } catch (error) {
            setError('Podajesz nieprawidłowe dane.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box component="form" onSubmit={handleLogin}>
            <TextField
                label="Email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                margin="normal"
                sx={{ backgroundColor: 'white' }}
            />
            <TextField
                label="Hasło"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                margin="normal"
                sx={{ backgroundColor: 'white' }}
            />
            {error && (
                <Typography variant="body2" color="error" sx={{ mt: '10px' }}>
                    {error}
                </Typography>
            )}
            <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                sx={{ mt: '20px' }}
            >
                {loading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Zaloguj'}
            </Button>
        </Box>
    );
};

export default Login;
